import React from 'react'
import { Box, Container, Typography, Grid } from '@mui/material'
import SEOMetaTags from '@/components/SEOMetaTags'
import { getSEOConfig, getCanonicalUrl } from '@/utils/seo'
import ResearchTopicCard from '@/components/research/ResearchTopicCard'
import { researchHubData } from '@/data/research/hub'

const ResearchHub: React.FC = () => {
  const seoConfig = getSEOConfig('/research')
  const canonicalUrl = getCanonicalUrl('/research')

  return (
    <Box component="main" role="main">
      <SEOMetaTags
        title={seoConfig?.title ?? researchHubData.metaTitle}
        description={seoConfig?.description ?? researchHubData.metaDescription}
        canonical={canonicalUrl}
        ogImage={seoConfig?.ogImage ?? '/images/og/default.jpg'}
        keywords={seoConfig?.keywords}
      />

      <Container maxWidth="md" sx={{ py: { xs: 4, md: 6 } }}>
        <Typography variant="h1" sx={{ mb: 3 }}>
          {researchHubData.heading}
        </Typography>

        <Typography variant="body1" sx={{ mb: 4, lineHeight: 1.8 }}>
          {researchHubData.introduction}
        </Typography>

        <Grid container spacing={3}>
          {researchHubData.topics.map(topic => (
            <Grid item key={topic.slug} xs={12} sm={6}>
              <ResearchTopicCard
                title={topic.title}
                description={topic.description}
                href={`/research/${topic.slug}`}
              />
            </Grid>
          ))}
        </Grid>
      </Container>
    </Box>
  )
}

export default ResearchHub
